var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-btn",
    {
      attrs: {
        loading: _vm.loading
      },
      on: {
        click: _vm.startAutoSsl
      }
    },
    [_vm._v(" Run AutoSSL Check ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }